//
// DeviceInfo.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "../models/TransportModel";

var DeviceInfo = createModule("transport::DeviceInfo", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        deviceType: 7,
        osVersion: 7,
        deviceModel: 7,
        deviceId: 7,
        mobileAppVersion: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DeviceInfo;
